import { FirebaseService } from './firebase/firebase-service';
import { ModelBase } from './model-base';

export class ServiceBase<T extends ModelBase> extends FirebaseService<T> {}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/service-base.ts